"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeKashidas = void 0;
function removeKashidas(text) {
    return (text
        // converts kashida between numbers to ndash
        .replace(/([0-9۰-۹]+)ـ+([0-9۰-۹]+)/g, "$1–$2")
        // removes all kashidas between non-whitespace characters
        // MAYBE: more punctuations
        .replace(/([^\s.])\u0640+(?![\s.])/g, "$1"));
}
exports.removeKashidas = removeKashidas;
